import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { ModalProvider } from "react-modal-hook";
import store from "./redux/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import App from "./App";
import ErrorBoundary from "./components/shared/ErrorBoundary";

// Outermost boundary: the last resort if the router or a provider throws.
// Individual screens are also wrapped (see routes/privateRoutes.js), so a
// broken screen keeps the shell usable; this one only catches what escapes it.
ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <Router>
        <ModalProvider>
          <App />
        </ModalProvider>
      </Router>
    </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
